<template>
  <div class="mt-2">
    <v-combobox
      label="Selecciona los modelos tarifarios váidos para el informe de etiquetas"
      clearable
      chips
      multiple
      :items="modelosTarifa"
      item-text="descripcion"
      item-value="id"
      v-model="vmodelModelosTarifa"
      model-value = "id"
      class="p-5 mx-5"
    ></v-combobox>
    <v-btn large dark fab absolute bottom right class="orange guardar" @click='guardar()'>
          <!-- {{ $t('lang.comun.guardar') }}-->
          <v-icon>save</v-icon>
    </v-btn>
  </div>

</template>
<script>
import { RegistroApiService } from '@/api/RegistroApiService'
import { TwisterRestApiService } from '@/api/TwisterRestApiService'

const registroApiService = new RegistroApiService()
const twisterRestApiService = new TwisterRestApiService()

export default {
  data() {
    return {
      modelosTarifa: [],
      regModelosTarifa: '',
      vmodelModelosTarifa: ''
    }
  },
  created() {
    this.cambioTitulo()
    this.getRegistroModelosTarifa()
    
   
  },
  methods :{
    cambioTitulo () {
      this.$store.state.tituloIcono = `<i class="icon-settings"></i>`
      this.$store.state.titulo = "Configuración"
    },
    getModelosTarifa() {
      twisterRestApiService.getModelosTarifa() 
        .then((data) => {
          this.modelosTarifa = data
          if (this.regModelosTarifa !== '') {
            this.vmodelModelosTarifa = data.filter(x => this.regModelosTarifa.split(',').some(y => y == x.id)) 
          } else {
            this.vmodelModelosTarifa = []
          }
        })
        .catch(error => {
          this.$root.$emit('mostrarAlerta', 'Error modelos tarifas', 'error')
          console.log(error)
        })
    },
    getRegistroModelosTarifa() {
      registroApiService.getRegistroById('modelos_tarifa_seleccionados') 
        .then((data) => {
          if (data) {
            this.regModelosTarifa = data.regTxt
          } else {
            this.regModelosTarifa = ''
          }
          this.getModelosTarifa()
        })
        .catch(error => {
          this.$root.$emit('mostrarAlerta', 'Error registro', 'error')
          console.log(error)
        })
    },
    guardar() {
      if (this.vmodelModelosTarifa !== '') {
        let registro = {
          regId: 'modelos_tarifa_seleccionados',
          regTxt: this.vmodelModelosTarifa.map(a => a.id).toString()
        }
        registroApiService.addRegistro(registro) 
          .then((data) => {
            if (data) {
              this.regModelosTarifa = data
            } else {
              this.regModelosTarifa = ''
            }
            this.$root.$emit('mostrarAlerta', 'Configuración guardada correctamente', 'info')
          })
          .catch(error => {
            this.$root.$emit('mostrarAlerta', 'Error registro', 'error')
            console.log(error)
          })
      } else {
        this.$root.$emit('Selecciona al menos un modelo tarifario', 'Error', 'error')
      } 
    }
  }
}
</script>
